import { RouteObject } from "react-router";

import * as Sentry from "@sentry/react";

import PageError from "@/helpers/components/Errors/PageError";

export const GroupsRoutes: RouteObject = {
	path: "groups/*",
	children: [
		{
			index: true,
			lazy: async () => {
				const { GroupsPage } = await import("@/components/Groups/GroupsPage");
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={({ error, componentStack, resetError }) => (
								<PageError
									error={error}
									componentStack={componentStack}
									reset={resetError}
								/>
							)}
						>
							<GroupsPage />
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
		{
			path: ":id",
			lazy: async () => {
				const { GroupPage } = await import("@/components/Groups/GroupPage");
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={({ error, componentStack, resetError }) => (
								<PageError
									error={error}
									componentStack={componentStack}
									reset={resetError}
								/>
							)}
						>
							<GroupPage />
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
	],
};
